import { Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import MargemBruta from '../pages/margemBruta';
import SalariosPorProjeto from '../pages/salariosPorProjeto';
import CustosPorProjeto from '../pages/lancamentos';
import SimuladorFolha from '../pages/simulacaoFolha';
import OrcamentoDash from '../pages/orcamentoDash'
import Login from '../pages/login';
import Register from '../pages/registro';
import Inicio from '../pages/inicio'
import PainelExecutivo from '../pages/painelExecutivo'
import Pagamentos from '../pages/pagamentos'

import PrivateRoute from '../PrivateRoute';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route 
        path="/margem-bruta" 
        element={
          <PrivateRoute allowedRoles={['admin' , 'financeiro', 'diretor','administracao']}>
            <MargemBruta />
          </PrivateRoute>
        } 
      />

      <Route 
        path="/salarios-por-projeto" 
        element={
          <PrivateRoute allowedRoles={['admin' , 'rh' , 'financeiro', 'diretor']}>
            <SalariosPorProjeto />
          </PrivateRoute>
        } 
      />

      <Route 
        path="/custos-por-projeto" 
        element={
          <PrivateRoute allowedRoles={['admin', 'rh','financeiro', 'diretor' , 'administracao']}>
            <CustosPorProjeto />
          </PrivateRoute>
        } 
      />

      <Route 
        path="/simulacao-folha" 
        element={
          <PrivateRoute allowedRoles={['admin' , 'rh' , 'financeiro', 'diretor']}>
            <SimuladorFolha />
          </PrivateRoute>
        } 
      />

      <Route 
        path="/orcamento-dash" 
        element={
          <PrivateRoute allowedRoles={['admin', "RH","TI","ADMFIN","NEGOCIOS","EXECUTIVA", "COMERCIAL","QUALIDADE","RH","JURIDICO","OPERACAO", ]}>
            <OrcamentoDash />
          </PrivateRoute>
        } 
      />

      <Route 
        path="/inicio" 
        element={
          <PrivateRoute>
            <Inicio />
          </PrivateRoute>
        } 
      />
       <Route 
        path="/painel-executivo" 
        element={
          <PrivateRoute allowedRoles={['admin' , 'financeiro', 'diretor']}>
            <PainelExecutivo />
          </PrivateRoute>
        } 
      />
       <Route 
        path="/painel-pagamentos" 
        element={
          <PrivateRoute allowedRoles={['admin' , 'financeiro', 'diretor']}>
            <Pagamentos />
          </PrivateRoute>
        } 
      />
    </Routes>
  );
}
